import { z } from "zod";
import { DEFAULT_CURRENCY_CODE, ItemTranslationSchema } from "../entities/menu.js";
import { INGREDIENT_NAME_MAX, REMOVABLE_INGREDIENTS_MAX } from "../entities/order.js";

export const CreateMenuCategoryRequestSchema = z.object({
  name: z.string().min(1).max(128),
});
export type CreateMenuCategoryRequest = z.infer<
  typeof CreateMenuCategoryRequestSchema
>;

export const UpdateMenuCategoryRequestSchema = z
  .object({
    name: z.string().min(1).max(128).optional(),
    isActive: z.boolean().optional(),
  })
  .refine(
    (body) => body.name !== undefined || body.isActive !== undefined,
    "provide a name, an active flag, or both",
  );
export type UpdateMenuCategoryRequest = z.infer<
  typeof UpdateMenuCategoryRequestSchema
>;

export const MoveMenuCategoryRequestSchema = z.object({
  direction: z.enum(["up", "down"]),
});
export type MoveMenuCategoryRequest = z.infer<
  typeof MoveMenuCategoryRequestSchema
>;

export const CreateMenuItemRequestSchema = z.object({
  categoryId: z.string().uuid().nullable(),
  sku: z.string().min(1).max(64),
  shortName: z.string().min(1).max(40).nullable().default(null),
  priceCents: z.number().int().nonnegative(),
  currency: z.string().length(3).default(DEFAULT_CURRENCY_CODE),
  imageUrl: z.string().url().nullable().default(null),
  isAvailable: z.boolean().default(true),
  remainingToday: z.number().int().nonnegative().nullable().optional(),
  removableIngredients: z
    .array(z.string().trim().min(1).max(INGREDIENT_NAME_MAX))
    .max(REMOVABLE_INGREDIENTS_MAX)
    .default([]),
  sortOrder: z.number().int().default(0),
  translations: z.array(ItemTranslationSchema).min(1),
});
export type CreateMenuItemRequest = z.infer<typeof CreateMenuItemRequestSchema>;

export const UpdateMenuItemRequestSchema =
  CreateMenuItemRequestSchema.partial();
export type UpdateMenuItemRequest = z.infer<typeof UpdateMenuItemRequestSchema>;
